import React from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { GrFormClose } from "react-icons/gr";
import { StoreContext } from "../../../../store/StoreContext";
import { InputText } from "../../../helpers/FormInputs";
import SpinnerButton from "../../../widget/SpinnerButton";
import { setIsAdd } from "../../../../store/StoreAction";
import { fetchData } from "../../../helpers/fetchData";

const ModalAddProgram = ({ edit, num, prog }) => {
  const { store, dispatch } = React.useContext(StoreContext);
  const [loading, setLoading] = React.useState(false);
  const { itemEdit, setItemEdit } = edit;

  const initVal = {
    program_aid: itemEdit ? itemEdit.program_aid : "",
    program_id: itemEdit ? itemEdit.program_id : num + 1,
    program_type: itemEdit ? itemEdit.program_type : prog,
    program_value: itemEdit ? itemEdit.program_value : "",
  };

  const yupSchema = Yup.object({
    program_value: Yup.string().required("Required"),
  });

  const handleClose = () => {
    dispatch(setIsAdd(false));
    setItemEdit(false);
  };

  return (
    <>
      <div className="modal modal-add-employee">
        <div className="display-center">
          <div className="title-container t-exbold notify-info">
            <h4 className="modal-title">
              <span className="color--blue">
                {itemEdit ? "Edit Program" : "Add Program"}
              </span>
            </h4>
            <span className="btn--close" onClick={handleClose}>
              <GrFormClose />
            </span>
          </div>
          <div className="bg--white">
            <Formik
              initialValues={initVal}
              validationSchema={yupSchema}
              onSubmit={(values, { setSubmitting, resetForm }) => {
                // console.log(values);
                fetchData(
                  setLoading,
                  itemEdit
                    ? "/admin/program/update-program.php"
                    : "/admin/program/create-program.php",
                  values, // form data values
                  null, // result set data
                  "", // success msg
                  "Server connection error. Please contact FBAS technical support.", // additional error msg if needed
                  dispatch, // context api action
                  store, // context api state
                  false, // boolean to show success modal
                  false // boolean to show load more functionality button
                );
                setItemEdit(false);
              }}
            >
              {(props) => {
                // console.log(props.isSubmitting);

                return (
                  <Form>
                    <div className="content-box">
                      <InputText
                        label="# of installment"
                        type="text"
                        name="program_id"
                        readOnly
                      />
                    </div>

                    <div className="content-box">
                      <InputText
                        label="Program type"
                        type="text"
                        name="program_type"
                        readOnly
                      />
                    </div>

                    <div className="content-box">
                      <InputText
                        label="Service value"
                        type="text"
                        name="program_value"
                        disabled={loading}
                      />
                    </div>

                    <div className="button-container">
                      <button type="submit" className="btn" disabled={loading}>
                        {itemEdit ? "SAVE" : "ADD"}{" "}
                        {loading && <SpinnerButton />}
                      </button>
                    </div>
                  </Form>
                );
              }}
            </Formik>
          </div>
        </div>
      </div>
    </>
  );
};

export default ModalAddProgram;
